export type SubscriptionExpiryInfo = {
  isExpiringSoon: boolean;
  daysUntilExpiry: number | null;
};

const EXPIRY_THRESHOLD_DAYS = 30;

export function getSubscriptionExpiryInfo(
  isoDate: string | null | undefined,
  thresholdDays: number = EXPIRY_THRESHOLD_DAYS
): SubscriptionExpiryInfo {
  if (!isoDate) {
    return { isExpiringSoon: false, daysUntilExpiry: null };
  }

  const expiry = new Date(isoDate);
  if (Number.isNaN(expiry.getTime())) {
    return { isExpiringSoon: false, daysUntilExpiry: null };
  }

  const now = new Date();
  const diffMs = expiry.getTime() - now.getTime();
  const daysUntilExpiry = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  if (daysUntilExpiry < 0) {
    return { isExpiringSoon: false, daysUntilExpiry: 0 };
  }

  return {
    isExpiringSoon: daysUntilExpiry <= thresholdDays,
    daysUntilExpiry,
  };
}
